import React from 'react'
import { Link } from 'react-router'
import { get } from 'lodash'
import PropTypes from 'prop-types'

import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/SharedBusinessRules'
import connectIndex from '../../lib/connectIndex'
import MatchingDataFieldDisplay from './helpers/MatchingDataFieldDisplay'
import CapitalizeValueDisplay from '../common/CapitalizeValueDisplay'
import JsonDisplay from '../common/JsonDisplay'

export class SharedBusinessRulesIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    includeSearch: PropTypes.bool,
    flashMessages: PropTypes.array.isRequired,
    filters: PropTypes.object,
    filterable: PropTypes.bool,
    filterActions: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    includeSearch: true,
    filterable: true,
    searchColumns: [
      'vericred_id',
      'shared_business_rule_type',
      'matching_type',
      'effective_date',
      'line_of_coverage',
      'audience',
      'issuer',
      'state',
      'brand_name'
    ]
  }

  // eslint-disable-next-line react/sort-comp
  static editLinkDisplay = (record) => {
    return (
      <Link
        title={record.vericred_id}
        to={{
          pathname: `/business_rules/${record.id}/edit`
        }}
      >{record.vericred_id}
      </Link>
    )
  }

  static capitalizeDisplay = (record, column) => {
    return CapitalizeValueDisplay(get(record, column.key))
  }

  static jsonDisplay = (record, column) => {
    return JsonDisplay(get(record, column.key))
  }

  static columns = [
    { key: 'vericred_id', label: 'Vericred ID', display: SharedBusinessRulesIndex.editLinkDisplay, sortable: false },
    { key: 'plans_count', label: '# Plans', sortable: false },
    { key: 'shared_business_rule_type', label: 'Business Rule Type', sortable: false, filterable: true },
    {
      key: 'payload',
      label: 'Business Rule Data',
      sortable: false,
      display: SharedBusinessRulesIndex.jsonDisplay
    },
    {
      key: 'matching_type',
      label: 'Matching Data Type',
      sortable: false,
      filterable: true,
      display: SharedBusinessRulesIndex.capitalizeDisplay
    },
    {
      key: 'matching_data',
      label: 'Matching Data',
      display: SharedBusinessRulesIndex.jsonDisplay,
      sortable: false
    },
    {
      key: 'line_of_coverage',
      label: 'Line of Coverage',
      display: MatchingDataFieldDisplay,
      sortable: false,
      filterable: true
    },
    {
      key: 'audience',
      label: 'Audience',
      display: MatchingDataFieldDisplay,
      sortable: false,
      filterable: true
    },
    { key: 'effective_date', label: 'Effective Date' },
    { key: 'expiration_date', label: 'Expiration Date' },
    { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
    { key: 'last_updated_by_username', label: 'Last Updated By', sortable: false }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/business_rules"
          name="Business Rules"
          pagination={this.props.pagination}
          columns={SharedBusinessRulesIndex.columns}
          flashMessages={this.props.flashMessages}
          filterable={this.props.filterable}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          records={this.props.records}
          includeSearch={this.props.includeSearch}
          searchColumns={this.props.searchColumns}
          history={this.props.history}
        />
      </div>
    )
  }
}

const filters = [
  {
    key: 'shared_business_rule_type',
    config: 'shared_business_rules.business_rule_types'
  },
  {
    key: 'line_of_coverage',
    config: 'shared_business_rules.line_of_coverages'
  },
  {
    key: 'audience',
    config: 'shared_business_rules.audiences'
  },
  {
    key: 'matching_type',
    config: 'shared_business_rules.matching_types'
  }
]

export default connectIndex(withRouter(SharedBusinessRulesIndex), 'sharedBusinessRules', actions, filters)
